import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Label from './Label';
import ActionText from '../../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';

class XLstructure extends Component {

  render() {

    const { onSelect, labels, noneFound, graph, activeLabel, schemeIRI, useWorkflow } = this.props;

    return (
      <div data-test="label-list">
        {noneFound || !labels ?
          <ActionText offset="100px" format="result">No results.</ActionText>
          :
          labels.map(label => <Label
            schemeIRI={schemeIRI}
            useWorkflow={useWorkflow}
            key={label}
            id={label}
            selected={activeLabel === label}
            graph={graph}
            onSelect={onSelect} />)
        }
      </div>
    );
  }

}

XLstructure.propTypes = {
  classes: PropTypes.object,
  schemeIRI: PropTypes.string,
  useWorkflow: PropTypes.bool,
  labels: PropTypes.array,
  activeLabel: PropTypes.string,
  graph: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  nonFound: PropTypes.bool
};

export default withStyles(styles)(XLstructure);